module.exports = __webpack_public_path__ + "img/payoneer.85caf5ac.svg";